import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import compact from 'lodash/compact';
import map from 'lodash/map';
import xor from 'lodash/xor';
import * as actions from './DetectSettings.ducks';

// landscape components
import Col from 'zignal-landscape/lib/Col';
import Grid from 'zignal-landscape/lib/Grid';
import GridContent from 'zignal-landscape/lib/GridContent';
import Heading from 'zignal-landscape/lib/Heading';
import Row from 'zignal-landscape/lib/Row';
import Select from 'zignal-landscape/lib/Select';
import Loading from 'zignal-landscape/lib/Loading';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Button from 'zignal-landscape/lib/Button';

export const mapStateToProps = (
  (state) => ({
    // Flags
    isInternalAdmin: state.AppUser.isInternalAdmin,
    fetchingDetectStreams: state.DetectSettings.fetchingDetectStreams,
    fetchingCampaign: state.DetectSettings.fetchingCampaign,
    updatingCampaign: state.DetectSettings.updatingCampaign,
    // DATA
    detectStreamsList: state.DetectSettings.detectStreamsList,
    campaign: state.DetectSettings.campaign,
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const DEFAULT_CAMPAIGN = {};
const DEFAULT_DETECT_STREAMS_LIST = [];

const DetectSettings = ({
  // passed from admin_router.coffee
  campaignId,
  accountId,
  isDetectEnabled,
  // actions
  fetchDetectStreams,
  fetchCampaign,
  updateCampaign,
  // flags
  isInternalAdmin,
  fetchingDetectStreams = true,
  fetchingCampaign = true,
  updatingCampaign = false,
  // data
  campaign = DEFAULT_CAMPAIGN,
  isDisabled = true,
  detectStreamsList = DEFAULT_DETECT_STREAMS_LIST
}) => {

  useEffect(() => {
    fetchDetectStreams();
  }, [fetchDetectStreams]);

  useEffect(() => {
    fetchCampaign({campaignId, accountId});
  }, [fetchCampaign, campaignId, accountId]);

  const loading = fetchingDetectStreams || fetchingCampaign;
  const { detectStreams=[] } = campaign;
  const campaignDetectStreams = compact(detectStreams.map((s) => {
    return detectStreamsList.find(({value}) => value === s.streamId);
  }));

  const updateDetectStreams = (selectedDetectStreams) => {
    const detectStreams = map(selectedDetectStreams, 'value');
    const campaignDetectStreamsValues = map(campaignDetectStreams, 'value');
    // only update when there is actually a change. Also, block while campaign is updating
    const shouldUpdate = updatingCampaign === false && xor(detectStreams, campaignDetectStreamsValues).length !== 0;
    if (shouldUpdate) {
      updateCampaign({...campaign, detectStreams});
    }
  };

  return (
    <GridContent style={{ minHeight: 160, position: 'relative' }}>
      <Grid fluid>
        {loading ? (
          <Loading />
        ) : (
          <>
            <Row>
              <Col xs={12}>
                <Heading>Detect Stream Access</Heading>
                <br />
                <br />
              </Col>
            </Row>
            <DetectSettingsSelect
              isDisabled={!isInternalAdmin || !isDetectEnabled}
              detectStreamsList={detectStreamsList}
              campaignDetectStreams={campaignDetectStreams}
              updateDetectStreams={updateDetectStreams}
              updatingCampaign={updatingCampaign}
            />
          </>
        )}
      </Grid>
    </GridContent>
  );
};

const DetectSettingsSelect = ({
  isDisabled,
  detectStreamsList,
  campaignDetectStreams,
  updateDetectStreams,
  updatingCampaign,
}) => {
  const [selectedDetectStreams, setSelectedDetectStreams] = useState(campaignDetectStreams);

  return (
    <>
      <Row style={isDisabled ? { cursor: 'not-allowed' } : {}}>
        <Col xs={1} style={{ lineHeight: '30px', fontWeight: 500 }}>
          Detect Streams
        </Col>
        <Col xs={2}>
          {
            <Select
              isMulti
              isDisabled={isDisabled}
              showArrow={!isDisabled}
              options={detectStreamsList}
              value={selectedDetectStreams}
              placeholder={!isDisabled ? 'Select...' : ''}
              onChange={!isDisabled ? setSelectedDetectStreams : noop}
            />
          }
        </Col>
      </Row>
      {!isDisabled ? (
        <Row>
          <br />
          <br />
          <ButtonGroup>
            <Button
              buttonStyle="positive"
              onClick={() => updateDetectStreams(selectedDetectStreams)}
              disabled={updatingCampaign}
            >
              Save
            </Button>
          </ButtonGroup>
        </Row>
      ) : null}
    </>
  );
};

DetectSettings.propTypes = {
  // passed from admin_router.coffee
  campaignId: PropTypes.string,
  accountId: PropTypes.string,
  isDetectEnabled: PropTypes.bool,
  // actions
  fetchDetectStreams: PropTypes.func,
  fetchCampaign: PropTypes.func,
  updateCampaign: PropTypes.func,
  // flags
  isInternalAdmin: PropTypes.bool,
  fetchingDetectStreams: PropTypes.bool,
  fetchingCampaign: PropTypes.bool,
  updatingCampaign: PropTypes.bool,
  // data
  detectStreamsList: PropTypes.array,
  campaign: PropTypes.object
};

export default connect(mapStateToProps, actions, mergeProps)(DetectSettings);
